// Author SWL
// Date 2022-12-13 09:54:21

class EmArchToolChange {
    constructor({
                    id = null,
                    initiator = '',
                    initiatorNumber = '',
                    initiatorLocation = '',
                    changeType = '',
                    changeTypeName = '',
                    warehouseKeeper = '',
                    warehouseKeeperNumber = '',
                    startTime = '',
                    planTime = '',
                    projectNumber = '',
                    attachments = '',
                    remark = '',
                    workOrderCode = '',
                    status = '',
                    attachmentsList = ''
                }
                    = {}) {
        this.id = id;
        this.initiator = initiator;
        this.initiatorNumber = initiatorNumber;
        this.initiatorLocation = initiatorLocation;
        this.changeType = changeType;
        this.changeTypeName = changeTypeName;
        this.warehouseKeeper = warehouseKeeper;
        this.warehouseKeeperNumber = warehouseKeeperNumber;
        this.startTime = startTime;
        this.planTime = planTime;
        this.projectNumber = projectNumber;
        this.attachments = attachments;
        this.remark = remark;
        this.workOrderCode = workOrderCode;
        this.status = status;
        this.attachmentsList = attachmentsList;
    }
}

function newEntity() {
    return new EmArchToolChange();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.archive.emArchToolChange.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'initiator',
            label: 'label.em.archive.emArchToolChange.grid.initiator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'initiatorNumber',
            label: 'label.em.archive.emArchToolChange.grid.initiatorNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'initiatorLocation',
            label: 'label.em.archive.emArchToolChange.grid.initiatorLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'changeType',
            label: 'label.em.archive.emArchToolChange.grid.changeType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'changeTypeName',
            label: 'label.em.archive.emArchToolChange.grid.changeTypeName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouseKeeper',
            label: 'label.em.archive.emArchToolChange.grid.warehouseKeeper',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouseKeeperNumber',
            label: 'label.em.archive.emArchToolChange.grid.warehouseKeeperNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'startTime',
            label: 'label.em.archive.emArchToolChange.grid.startTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'planTime',
            label: 'label.em.archive.emArchToolChange.grid.planTime',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectNumber',
            label: 'label.em.archive.emArchToolChange.grid.projectNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentsList',
            label: 'label.em.archive.emArchToolChange.grid.attachmentsList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.archive.emArchToolChange.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.em.archive.emArchToolChange.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.em.archive.emArchToolChange.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    initiatorFilter: '',
    initiatorNumberFilter: '',
    initiatorLocationFilter: '',
    changeTypeFilter: '',
    changeTypeNameFilter: '',
    warehouseKeeperFilter: '',
    warehouseKeeperNumberFilter: '',
    startTimeRteFilter: '',
    startTimeLteFilter: '',
    planTimeRteFilter: '',
    planTimeLteFilter: '',
    projectNumberFilter: '',
    workOrderCodeFilter: '',
    statusFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'initiatorFilter',
        label: 'label.em.archive.emArchToolChange.filter.initiator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'initiatorNumberFilter',
        label: 'label.em.archive.emArchToolChange.filter.initiatorNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'initiatorLocationFilter',
        label: 'label.em.archive.emArchToolChange.filter.initiatorLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'changeTypeFilter',
        label: 'label.em.archive.emArchToolChange.filter.changeType',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchToolChangeType'
            , correspondingField: 'id'
        }
    },
    {
        key: 'changeTypeNameFilter',
        label: 'label.em.archive.emArchToolChange.filter.changeTypeName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'warehouseKeeperFilter',
        label: 'label.em.archive.emArchToolChange.filter.warehouseKeeper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'warehouseKeeperNumberFilter',
        label: 'label.em.archive.emArchToolChange.filter.warehouseKeeperNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.em.archive.emArchToolChange.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.em.archive.emArchToolChange.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planTimeRteFilter',
        label: 'label.em.archive.emArchToolChange.filter.planTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planTimeLteFilter',
        label: 'label.em.archive.emArchToolChange.filter.planTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNumberFilter',
        label: 'label.em.archive.emArchToolChange.filter.projectNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.em.archive.emArchToolChange.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.em.archive.emArchToolChange.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'EmArchToolChange', statusFilter: 1}
        }
    },
];


const entityFormConfigs = [

    {
        key: 'initiatorLocation',
        label: 'label.em.archive.emArchToolChange.entity.initiatorLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
            , required: true
            , modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'changeType',
        label: 'label.em.archive.emArchToolChange.entity.changeType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , required: true
            , modalMultiSelectedType: 'string'
            , entity: 'emArchToolChangeType'
            , correspondingField: 'id'
        }
    },
    {
        key: 'changeTypeName',
        label: 'label.em.archive.emArchToolChange.entity.changeTypeName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planTime',
        label: 'label.em.archive.emArchToolChange.entity.planTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            required: true,
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNumber',
        label: 'label.em.archive.emArchToolChange.entity.projectNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.archive.emArchToolChange.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentsList',
        label: 'label.em.archive.emArchToolChange.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachments'
        }
    }
]

export {
    EmArchToolChange, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
